module.exports = __webpack_public_path__ + "static/media/akkurat-mono-webfont.9366c235.ttf";